<template>
	<div>
		<v-select 
			data-cy="timezone-select"
			:clearable="false"
			@input="updateValue"
			label="name" 
			:value="value"
			:options="zones"
			ref="dropdown"
		></v-select>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
	props: ['value', "modalView"],
	data() {
		return {
			zones: []
		}
	},
	mounted() {
		// populate zones
		moment.tz.names().map((i) => {
			var tz = moment.tz(i);
			var gmtDelta = tz.format("Z");

			this.zones.push({
				name: tz.tz(), 
				offset: tz.utcOffset(),
				gmtDelta: gmtDelta
			});
		});

		this.zones = _.sortBy(this.zones, (i) => { return i.offset })
	},
	methods: {
		updateValue(value) {
			this.$emit("input", value);
			if (this.modalView) {this.$emit("close-modal");}
		},
		openSelect() {
			this.$refs.dropdown.select(this.value);	
		}
	}
}
</script>
